<template>
  <div class="careers-page">
    <NavBar />
    <div class="content">
      <div class="text-content">
        <h2>We’re Always Looking for More Genius.</h2>
        <h4>
          Join our community of student advisors from top universities and Ivy League schools, 
          and help guide the next generation through their college journey.
        </h4>
        <p>
          At College Genius, we believe the best advice comes from those who’ve lived it. 
          That’s why our advisors are real students from top 50 universities and Ivy League campuses — 
          sharing insider tips, proven strategies, and personal experiences to make the college 
          application process less stressful and more successful.
        </p>
        <p>
          Whether you’re passionate about essay editing, test prep, extracurricular planning, 
          or financial aid guidance, your knowledge can make a life-changing impact on future applicants.
        </p>
        <h4>What We Offer:</h4>
        <ul>
          <li>Remote and Flexible hours that work around your class schedule.</li>
          <li>Competitive pay per session.</li>
          <li>Training and resources to help you succeed as an advisor.</li>
          <li>A chance to build your resume while giving back.</li>
          <li>Be part of a network of ambitious, inspiring peers.</li>
        </ul>
      </div>


      <div class="form-container">
        <h3>Think you’ve got some Genius?</h3>
        <p class="form-subheadline">
          Apply today and start shaping the future for students just like you
        </p>

        <form @submit.prevent="submitForm">
          <div class="form-group">
            <label>First Name</label>
            <input type="text" v-model="formData.first_name" placeholder="Enter your first name" required />
          </div>

          <div class="form-group">
            <label>Last Name</label>
            <input type="text" v-model="formData.last_name" placeholder="Enter your last name" required />
          </div>

          <div class="form-group">
            <label>Email</label>
            <input type="email" v-model="formData.email" placeholder="Enter your email" required />
          </div>

          <div class="form-group">
            <label>Why would you be a great advisor?</label>
            <textarea
              class="career-form-textarea"
              v-model="formData.message"
              placeholder="Tell us about your strengths, experiences, and interests"
              required
            ></textarea>
          </div>

          <div class="form-group file-upload">
            <label>Attach Resume (PDF, DOCX)</label>
            <input type="file" id="fileUpload" @change="handleFileUpload" />
          </div>

          <button type="submit" :disabled="isSubmitting">
            {{ isSubmitting ? 'Sending...' : 'Submit Application' }}
          </button>

          <div v-if="submitMessage" class="submit-message" :class="{ 'error': submitError }">
            {{ submitMessage }}
          </div>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import NavBar from "./../../components/NavBar.vue";

export default {
  name: "CareersView",
  components: {
    NavBar
  },
  data() {
    return {
      formData: {
        first_name: '',
        last_name: '',
        email: '',
        message: '',
        file: null
      },
      isSubmitting: false,
      submitMessage: '',
      submitError: false,
      debugInfo: null,
      isDevelopment: false // Always hide debug info
    };
  },
  methods: {
    handleFileUpload(event) {
      this.formData.file = event.target.files[0];
    },
    async submitForm() {
      this.isSubmitting = true;
      this.submitMessage = '';
      this.submitError = false;

      try {
        const payload = new FormData();
        payload.append("first_name", this.formData.first_name);
        payload.append("last_name", this.formData.last_name);
        payload.append("email", this.formData.email);
        payload.append("message", this.formData.message);
        if (this.formData.file) {
          payload.append("file", this.formData.file);
        }

        const response = await fetch("https://college-genius-moh3.onrender.com/submit-career", {
          method: "POST",
          body: payload
        });

        if (response.ok) {
          const data = await response.json();
          this.submitMessage = data.message || "Thank you for applying!";
          this.formData = { first_name: "", last_name: "", email: "", message: "", file: null };
        } else {
          this.submitError = true;
          this.submitMessage = "An error occurred. Please try again.";
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        this.submitError = true;
        this.submitMessage = "Connection error. Please try again later.";
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<style scoped>
.careers-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333;
  font-family: Arial, sans-serif;
  background-image: url("backg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 100vh;  
  padding-top: 5rem;
  box-sizing: border-box;

}

.content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  max-width: 1200px;
  margin: auto;
  padding: 50px 0;
  border-radius: 15px;

  gap: 40px;
}

.text-content {
  color: white;
  text-align: left;
  width: 50%;
}

.text-content h2 {
  font-size: 3em;
  line-height: 1.25;
  font-weight: bold;
  margin-bottom: 10px 0px;
  color: #ffffff;
}

.text-content h4 {
  font-size: 1.3em;
  line-height: 1.5;
  margin: 20px 0 10px;
  color: #fccb2e;
}

.text-content p {
  font-size: 1.2em;
  line-height: 1.5;
  margin: 20px 0px;
  color: #ffffff;
}

.text-content ul {
  list-style: none;           /* remove default */
  padding-left: 0;
}

.text-content li {
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
  color: #ffffff;
}

.text-content li::before {
  content: "•";               /* custom bullet */
  color: #ffd700;             /* gold bullet */
  font-size: 1.2em;
  position: absolute;
  left: 0;
  top: 0;
}

.form-container {
  width: 45%;
  max-width: 520px;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 40px 30px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
}

.form-container h3 {
  text-align: center;
  font-size: 2em;
  font-weight: bold;
  color: #222;
  margin-bottom: 10px;
}

.form-subheadline {
  text-align: center;
  color: #666;
  font-size: 1em;
  margin-bottom: 25px;
}

form {
  display: flex;
  flex-direction: column;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 0.9em;
  margin-bottom: 6px;
  color: #444;
  font-weight: 600;
}

input,
textarea {
  border-radius: 10px;
  border: 1px solid #d1d1d1;
  padding: 12px 14px;
  font-size: 1em;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

input:focus,
textarea:focus {
  border-color: #3867ae;
  box-shadow: 0 0 0 3px rgba(56, 103, 174, 0.2);
}

textarea {
  min-height: 120px;
  resize: vertical;
  line-height: 1.5;
}

textarea::placeholder,
input::placeholder {
  color: #999;
  font-size: 0.95em;
}

.file-upload input[type="file"] {
  border: none;
  font-size: 0.95em;
  padding: 6px 0;
}

button {
  background: linear-gradient(135deg, #3867ae, #2e548a);
  height: 50px;
  border: none;
  color: #fff;
  font-size: 1.1em;
  font-weight: bold;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.3s, transform 0.1s;

  display: flex;               
  align-items: center;         
  justify-content: center;     
}

button:hover:not(:disabled) {
  background: linear-gradient(135deg, #4a7ed3, #2e548a);
  transform: translateY(-1px);
}

button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.submit-message {
  margin-top: 20px;
  padding: 12px;
  border-radius: 8px;
  text-align: center;
  font-weight: 500;
  background-color: #d4edda;
  color: #155724;
}

.submit-message.error {
  background-color: #f8d7da;
  color: #721c24;
}

@media (max-width: 768px) {
  .form-container {
    width: 90%;
    padding: 25px;
  }
}


.debug-info {
  margin-top: 20px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 5px;
  font-size: 0.8em;
  color: #666;
  overflow-x: auto;
}

.debug-info pre {
  white-space: pre-wrap;
  word-break: break-all;
}

/* On smaller screens, stack vertically */
@media (max-width: 768px) {
  .content {
    flex-direction: column;   /* Stack instead of row */
    align-items: center;
    text-align: left;       /* Center text on mobile */
  }

  .text-content, 
  .form-container {
    width: 100%;             /* Take full width on small screens */
    max-width: 100%;
  }

  .text-content h2 {
    font-size: 2em;          /* Scale down heading for smaller screens */
  }

  .form-container {
    margin-top: 20px;        /* Space between text and form */
  }
}
</style>